import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "calculator-loader-panel" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "calculator-loader-ring",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_3 = { class: "calculator-loader-label mb-0" }

import { computed } from "vue";
import { useI18n } from "vue-i18n";


export default /*#__PURE__*/_defineComponent({
  __name: 'CalculatorLoader',
  props: {
    fixed: { type: Boolean, default: false },
    anchor: { default: "center" },
    label: { default: "" }
  },
  setup(__props: any) {

const props = __props as { fixed: boolean, anchor: "center" | "top", label: string };



const { t } = useI18n();

const accessibleLabel = computed(() => props.label || t("message.UI_LOADING"));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["calculator-loader-shell", {
      'calculator-loader-shell--fixed': __props.fixed,
      'calculator-loader-shell--fixed-top': __props.fixed && __props.anchor === 'top',
    }]),
    role: "status",
    "aria-live": "polite",
    "aria-busy": "true"
  }, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("p", _hoisted_3, _toDisplayString(_unref(accessibleLabel)), 1)
    ])
  ], 2))
}
}

})